import { FC, createElement } from 'react';

type AllowedElements = 'p' | 'span' | 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export interface DynamicTypographyProps {
  content?: string;
  className?: string;
  withoutSpace?: boolean;
  component?: AllowedElements;
}

export const DynamicTypography: FC<DynamicTypographyProps> = ({
  content,
  className = '',
  withoutSpace = false,
  component = 'p'
}) => {
  const chunks = content?.split(/(\*.*?\*)/g).filter(Boolean);

  return createElement(
    component,
    { className: `dynamic-typo ${className}`.trim() },
    chunks?.map((chunk, index) => {
      if (chunk.startsWith('*') && chunk.endsWith('*')) {
        return <strong key={`chunk-${index}`}>{chunk.slice(1, -1).trim()}</strong>;
      }
      return chunk + (!withoutSpace ? ' ' : '');
    })
  );
};
